import request from '@/utils/request'

//列表接口
export function getList(data) {
    return request({
        url: '/backend/dyClueSync/get-list',
        method: 'post',
        data: data
    })
}

//关联体验营
export function syncCourse(data) {
    return request({
        url: '/backend/dyClueSync/sync-course',
        method: 'post',
        data: data
    })
}

//筛选体验营列表
export function screenExperienceList(data) {
    return request({
        url: '/backend/dyClueSync/screen-experience-list',
        method: 'post',
        data: data
    })
}

//课程工具列表
export function getCourseToolList(data) {
    return request({
        url: '/backend/dyClueSync/course-tool-list',
        method: 'post',
        data: data
    })
}

//添加工具
export function addTool(data) {
    return request({
        url: '/backend/dyClueSync/add-tool',
        method: 'post',
        data: data
    })
}

//删除工具
export function delTool(data) {
    return request({
        url: '/backend/dyClueSync/del-tool',
        method: 'post',
        data: data
    })
}